'use client';
/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-07 10:41:09
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-05-13 15:41:32
 * @FilePath: /zeelool-nextjs/src/components/Address/CountryDialog.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Country } from '@/api/types/public';
import { useStore } from '@/providers/app-store-provider';
import { colors } from '@/theme/zeelool.theme';
import { Drawer } from '@mui/material';
import { WapNavBackOutlined } from '@zeelool/icon';
import { useTranslations } from '@/i18n/use-translations';
import { useEffect, useState } from 'react';
import MobileNav from '../MobileNav';

export default function MobileCountryDrawer({
  show,
  close,
  onSelect = () => {},
  zIndex,
}: {
  show: boolean;
  close: () => void;
  onSelect?: (country?: Country) => void;
  zIndex?: number;
}) {
  const t = useTranslations('address');
  const indexList = [
    '#',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    '?', // 兼容奥兰群岛
  ];
  const countryList = useStore((state) => state.countryList);
  const country: { [key: string]: Country[] } = {};
  indexList.forEach((item) => {
    country[item] = [];
  });
  countryList.forEach((item) => {
    country[item.initial].push(item);
  });
  const [activedIndex, setActivedIndex] = useState('#');

  const scrollTo = (index: string) => {
    const element = document.getElementById(`item-${index}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActivedIndex(index);
    }
  };
  let timer = null;
  const scrollToSetActived = (event) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      let active = '';
      const { scrollTop } = event.target;
      for (let i = 0; i < indexList.length; i++) {
        const ele = document.getElementById(`item-${indexList[i]}`);
        if (ele && scrollTop >= ele.offsetTop && scrollTop < ele.offsetTop + ele.offsetHeight) {
          active = indexList[i];
          break;
        }
      }
      setActivedIndex(active);
    }, 100);
  };

  useEffect(() => {
    if (show) {
      setActivedIndex('#');
    }
  }, [show]);

  return (
    <Drawer
      open={show}
      sx={zIndex === undefined ? undefined : { zIndex }}
      PaperProps={{
        sx: {
          width: '100%',
          height: '100vh',
          background: colors.auxiliaryGray,
        },
      }}
    >
      <div className="h-[100vh] flex flex-col font-br">
        <MobileNav
          className="bg-white min-h-[50px]"
          title={t('pleaseSelect')}
          titleClassName="text-center w-full"
          leftSlot={
            <div
              className="MobileNav flex items-center justify-center h-[40px] w-[40px] absolute left-0 top-5"
              onClick={close}
            >
              <WapNavBackOutlined className="text-20" />
            </div>
          }
        />
        <div
          className="relative flex-grow-1 flex-shrink-0"
          style={{ height: 'calc(100vh - 50px)' }}
        >
          <div className="fixed right-4 flex flex-col top-[55%] transform -translate-y-1/2">
            {indexList.map((item) => (
              <div
                key={`nav-${item}`}
                className="flex items-center justify-center w-[18px] h-[18px] pt-2 rounded-[9px] text-[10px] text-secondary-text"
                style={{
                  color: activedIndex === item ? colors.primaryWhite : colors.secondaryText,
                  background: activedIndex === item ? colors.primaryPurple : 'none',
                }}
                onClick={() => scrollTo(item)}
              >
                {item}
              </div>
            ))}
          </div>
          <div onScroll={scrollToSetActived} className="h-[100%] overflow-y-auto pb-64">
            {indexList.map((item) => (
              <div id={`item-${item}`} key={`item-${item}`} className="CountryItemContainer">
                <div className="pl-16 pr-16 leading-[32px] color text-14 text-primary-black-hover">
                  {item}
                </div>
                <div className="bg-white pl-16 pr-16">
                  {country[item].map((ele) => (
                    <div
                      key={ele.country_id}
                      className="border-b-1 pt-20 pb-20 border-b-auxiliary-light-gray-blue last:border-b-0 text-14 text-primary-black"
                      onClick={() => {
                        onSelect(ele);
                        close();
                      }}
                    >
                      {ele.country}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Drawer>
  );
}
